import React from "react";
import achive1 from "../../assets/certificate.jpg";
import achive2 from "../../assets/balckBelt.png";
import achive3 from "../../assets/Achievement.png";

const Achievement = () => {
  return (
    <div className="after:absolute after:content-['Achievement']  after:tracking-widest after:text-own-gray-black after:text-[4rem]   sm:after:text-[5rem] after:opacity-50 after:left-[50%] after:-translate-x-[50%] relative after:-z-10 after:top-[150px] after:font-semibold">
      <div className="md:w-[800px] w-[90%] mx-auto">
        <div className="flex items-center flex-col">
          <img src={achive3} alt="" />
          <h1 className="text-center font-semibold text-3xl text-own-secondary mt-[-20px]">
            Achievement
          </h1>
        </div>
        <div className="">
          <p className="text-center  text-[18px]">
            I have done MERN stack course on Programing hero where <br /> I was
            <span className="text-own-secondary font-semibold"> top 5%</span> of
            the class and got{" "}
            <span className="text-own-secondary font-semibold">Black Belt</span>{" "}
            Title as web developer
          </p>
          <div className="flex justify-around mt-10">
            <div className="flex items-center justify-center bg-own-primary bg-opacity-20 border-2 border-own-border-color p-5 border-opacity-10 m-2">
              <img className="w-[300px]" src={achive1} alt="" />
            </div>
            <div className="flex items-center justify-center bg-own-primary bg-opacity-20 border-2 border-own-border-color p-5 border-opacity-10 m-2">
              <img className="w-[300px]" src={achive2} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Achievement;
